const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const appLocalizer = window.appLocalizer;
import React, { useEffect, useRef } from "react";
import { service } from '../services/service';

const {
    AlignmentToolbar,
    BlockControls,
    InspectorControls } = wp.editor;

const {
    PanelBody,
    RangeControl,
    ToggleControl,
    SelectControl
} = wp.components;

import { ReactComponent as Logo } from "../bv-logo.svg";

registerBlockType("wpfiles/block-wpfiles-gallery", {
    title: __("WPFiles Gallery", "wpfiles"),
    icon: { src: Logo },
    category: "common",
    attributes: {
        isLoading: {
            type: "boolean",
            default: !1
        },
        captions: {
            type: "object",
            default: {}
        },
        imagesRemoved: {
            type: "array",
            default: []
        },
        images: {
            type: "array",
            default: []
        },
        selectedFolder: {
            type: "array",
            default: []
        },
        columns: {
            type: "integer",
            default: 3
        },
        isCropped: {
            type: "boolean",
            default: !0
        },
        hasCaption: {
            type: "boolean",
            default: !1
        },
        // hasMasonryGrid: {
        //     type: "boolean",
        //     default: !1
        // },
        linkTo: {
            type: "string",
            default: "none"
        },
        sortBy: {
            type: "string",
            default: wp.media.model.Query.defaultProps.orderby
        },
        sortType: {
            type: "string",
            default: wp.media.model.Query.defaultProps.order
        },
        html: {
            type: "string",
            default: "none"
        },
    },
    supports: {
        align: ['wide', 'full']
    },

    edit: props => {

        const _isMounted = useRef(true);

        // Lift info from props and populate various constants.
        const {
            attributes: {
                descriptionAlignment,
                selectedFolder,
                columns,
                isCropped,
                hasCaption,
                //hasMasonryGrid,
                linkTo,
                sortBy,
                sortType,
                html
            },
            className,
            setAttributes
        } = props;

        // When folder change
        const onChangeFolder = (selectedFolder) => {
            setAttributes({ selectedFolder: [selectedFolder] });
        };

        // Grab newDescriptionAlignment, set the value of descriptionAlignment to newDescriptionAlignment.
        const onChangeDescriptionAlignment = newDescriptionAlignment => {
            setAttributes({ descriptionAlignment: newDescriptionAlignment });
        };

        //Recursive folder component 
        const RecursiveComponent = (props) => {
            return (
                <React.Fragment>
                    {props.folders && props.folders.map((folder, key) =>
                        <React.Fragment>
                            <option selected={Number(props.selectedFolder) === Number(folder.id) ? true : false} value={folder.id}>{props.staric && props.staric}{folder.text}</option>
                            {folder.children && folder.children.length > 0 && (
                                <RecursiveComponent selectedFolder={props.selectedFolder} folders={folder.children} staric={props.staric ? props.staric + "*" : "*"} />
                            )}
                        </React.Fragment>
                    )}
                </React.Fragment>
            )
        }

        useEffect(() => {
            if (selectedFolder.length > 0) {
                loadImages();
            }
        }, [selectedFolder, columns, isCropped, hasCaption/*, hasMasonryGrid*/, linkTo, sortType, sortBy]);

        const loadImages = () => {
            service.put(`${appLocalizer.apiUrl}/gutenberg-get-images`, { columns: columns, isCropped: isCropped, hasCaption: hasCaption, /*hasMasonryGrid: hasMasonryGrid,*/ linkTo: linkTo, sortType: sortType, sortBy: sortBy, selectedFolder: selectedFolder }, appLocalizer.nonce)
                .then(
                    response => {
                        if (_isMounted.current) {
                            setAttributes({ html: response.html });
                        }
                    },
                    error => { }
                );
        }

        useEffect(() => {
            return () => {
                _isMounted.current = false;
            }
        }, []);

        return [
            <InspectorControls>
                <PanelBody title={__('Folders', "wpfiles")}>
                    <div className="components-base-control">
                        <div className="components-base-control__field">
                            {appLocalizer.terms && appLocalizer.terms && appLocalizer.terms.length > 0 && (
                                <select onChange={(event) => {
                                    onChangeFolder(event.target.value);
                                }}>
                                    <RecursiveComponent selectedFolder={selectedFolder} folders={appLocalizer.terms && appLocalizer.terms} />
                                </select>
                            )}
                            <br />
                            <br />
                            <br />
                            <RangeControl
                                label="Columns"
                                value={columns}
                                onChange={(value) => setAttributes({ columns: value })}
                                min={1}
                                max={4}
                            />
                            <br />
                            <ToggleControl
                                label="Crop Images"
                                help="Thumbnails are cropped to align."
                                checked={isCropped}
                                onChange={() => {
                                    setAttributes({ isCropped: !isCropped })
                                }}
                            />
                            <ToggleControl
                                label="Caption"
                                help="Display image caption."
                                checked={hasCaption}
                                onChange={() => {
                                    setAttributes({ hasCaption: !hasCaption })
                                }}
                            />
                            {/* <ToggleControl
                                label="Masonry grid"
                                help="Grid layout based on columns."
                                checked={hasMasonryGrid}
                                onChange={() => {
                                    setAttributes({ hasMasonryGrid: !hasMasonryGrid })
                                }}
                            /> */}
                            <SelectControl
                                label="Link To"
                                value={linkTo}
                                options={[
                                    { label: 'None', value: 'none' },
                                    { label: 'Attachment Page', value: 'attachment' },
                                    { label: 'Media File', value: 'media' },
                                    { label: 'Lightbox', value: 'lightbox' }
                                ]}
                                onChange={(linkTo) => setAttributes({ linkTo: linkTo })}
                            />
                            <SelectControl
                                label="Sort By"
                                value={sortBy}
                                options={[
                                    { label: 'By Name', value: 'name' },
                                    { label: 'By Date', value: 'date' },
                                    { label: 'By Modified', value: 'modified' },
                                    { label: 'By Author', value: 'author' },
                                    { label: 'By Title', value: 'title' },
                                    { label: 'By File Name', value: 'file_name' },
                                ]}
                                onChange={(sortBy) => setAttributes({ sortBy: sortBy })}
                            />
                            <SelectControl
                                label="Sort Type"
                                value={sortType}
                                options={[
                                    { label: 'Ascending', value: 'ASC' },
                                    { label: 'Descending', value: 'DESC' }
                                ]}
                                onChange={(sortType) => setAttributes({ sortType: sortType })}
                            />
                        </div>
                    </div>
                </PanelBody>
            </InspectorControls>,
            <div
                className={`${className}`}>
                <BlockControls>
                    <AlignmentToolbar
                        value={descriptionAlignment}
                        onChange={onChangeDescriptionAlignment}
                    />
                </BlockControls>
                <div dangerouslySetInnerHTML={{ __html: html ? html : "No post" }}></div>
            </div>
        ];
    },
    save: props => {

        const {
            attributes: {
                html
            }
        } = props;

        return (
            <div dangerouslySetInnerHTML={{ __html: html ? html : "No post" }}></div>
        );
    }
});
